import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import listTicketsStore from 'entities/beket/models/ticket/beket-list-tickets/beket-list-tickets-store.ts'

import { BeketTicket } from 'shared/api/beket/search'
import Loop from 'shared/images/glasss.png'
import { prepareBeketRouteData } from 'shared/lib/prepareBeketRouteData.tsx'
import { EmptyPage } from 'shared/ui/empty-page'
import { Loader } from 'shared/ui/loader'

import { BeketResultsCard } from './components/beket-results-card'
import s from './styles.module.scss'

export const BeketSearchList = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const listTicket = listTicketsStore.getListTickets()
  const isLoading = listTicketsStore.loading

  const isEmpty = !isLoading && listTicket?.length === 0

  const onClickCard = (ticket: BeketTicket) => {
    navigate(RoutingPaths.beket.tripDetails.path(String(ticket.id)), {
      state: {
        searchKey: listTicketsStore.searchKey || '',
      },
    })
  }

  return (
    <div className={s.cardList}>
      {isEmpty ? (
        <EmptyPage
          title={t('beket_content.empty_list_title')}
          subTitle={t('beket_content.empty_list_description')}
          image={Loop}
          isBeket
        />
      ) : isLoading ? (
        <Loader marginTop={120} />
      ) : (
        listTicket?.map((ticket) => (
          <BeketResultsCard
            key={ticket.id}
            ticket={ticket}
            routeData={prepareBeketRouteData(ticket)}
            onClick={() => onClickCard(ticket)}
          />
        ))
      )}
    </div>
  )
})
